<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">Home</a></li>
                            <li><a href="/colaborador" title="Colaboradores / Candidatos">Colaboradores / Candidatos</a></li>
                            <li>Detalhes</li>
                        </ul>
                    </section>

                    <section class="col-sm-6" v-if="escolaLogadaId == 276">
                        <label>&nbsp;</label>
                        <select v-select="{ dataitem: 'Escola', default: 'Selecione' }" v-model="escolaId" class="form-control" name="escolaId" @change="trocarEscolaSimulacao()"></select>
                    </section>

                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Detalhes Colaboradores / Candidatos</b></h2>
                    </div>

                    <b-tabs v-if="dialogEdit" v-model="tabIndex">
                        <b-tab title="Dados Principais">
                            <br />
                            <div class="mold-txt-center">
                                <form-edit v-if="dialogEdit" :id="colaboradorId" :has-disabled="true" @on-saved="onSaved" @on-back="onBack()" />
                            </div>
                        </b-tab>

                        <b-tab title="Endereço">
                            <br />
                            <colaboradorendereco-form-edit :colaborador-id="colaboradorId" :has-disabled="true" />
                        </b-tab>

                        <b-tab title="Informações Complementares">
                            <br />
                            <colaborador-form-academica :colaborador-id="colaboradorId" :has-disabled="true" />
                            <hr />
                            <colaborador-exp-profissional :colaborador-id="colaboradorId" :has-disabled="true" />
                            <hr />
                            <colaborador-curso :colaborador-id="colaboradorId" :has-disabled="true" />
                            <hr />
                            <colaborador-treinamento :colaborador-id="colaboradorId" :escola-id="escolaId" v-if="sessaoTreinamento" :ehDetalhe="true" />
                        </b-tab>

                        <b-tab title="Testes">
                            <br />
                            <candidato-content :escola-id="escolaId" :colaborador-id="colaboradorId" :has-disabled="true" />
                        </b-tab>

                        <b-tab title="Escolas" v-if="escolaId == 276">
                            <br />
                            <colaborador-escola :escola-id="escolaId" :colaborador-id="colaboradorId" :has-disabled="true" />
                        </b-tab>

                        <b-tab title="Cargo" v-if="escolaId != 276">
                            <br />
                            <colaborador-escola-cargo :mostrar-campos="false" :colaborador-id="colaboradorId" :escola-id="escolaId" :has-disabled="true"/>
                        </b-tab>

                    </b-tabs>
                </div>
            </div>
        </section>


    </main>

</template>
<script>

    import auth from '@/common/auth'
    import { Api } from '@/common/api'
    import formEdit from './form-edit'
    import colaboradorExpProfissional from './colaboradorexpprofissional'
    import colaboradorEscola from './colaboradorescola'
    import colaboradorCurso from './colaboradorcurso'
    import colaboradorFormAcademica from './colaboradorformacademica'
    import colaboradorTreinamento from './colaboradortreinamento'
    import candidatoContent from '../candidato/content'
    import colaboradorTag from './colaboradorescola/colaboradortag'
    import colaboradorEscolaCargo from './colaboradorescola/colaboradorescolacargo'
    import colaboradorenderecoFormEdit from './colaboradorendereco/form-edit'
    import TutorStep from '@/common/tutor-step'

    export default {
        name: 'colaborador-edit',
        components: {
            formEdit,
            colaboradorExpProfissional,
            colaboradorEscola,
            colaboradorCurso,
            colaboradorFormAcademica,
            candidatoContent,
            colaboradorTag,
            colaboradorEscolaCargo,
            colaboradorenderecoFormEdit,
            colaboradorTreinamento
        },
        data: () => ({
            tabIndex: 0,
            dialogEdit: false,
            colaboradorId: 0,
            escolaId: 0,
            escolaLogadaId: 0,
            sessaoTreinamento: false
        }),
        watch: {
            tabIndex: function (tabIndex) {
              
                if (tabIndex == 3) TutorStep.start("/colaborador/teste");
                if (this.escolaLogadaId != 276) {
                    if (tabIndex == 4) TutorStep.start("/colaborador/cargo");
                }
                else {
                    if (tabIndex == 5) TutorStep.start("/colaborador/cargo");
                }
            }
        },
        methods: {
            onSaved: function (data) {
                if (data) this.$router.push({ path: '/colaborador' });
            },
            onBack: function () {
                this.$router.go(-1);
            },
            trocarEscolaSimulacao: function () {
                this.dialogEdit = false;
                if (this.escolaId) {
                    this.escolaId = +this.escolaId;
                    setTimeout(() => { this.dialogEdit = true }, 1000)
                }
            },
            verificaSessaoTreinamento: function () {
                //this.dialogEdit = false;
                new Api('colaborador/ColaboradorSessaoTreinamento').get({ colaboradorId: this.colaboradorId }).then(data => {
                    if (data.data)
                        this.sessaoTreinamento = true;
                    else
                        this.sessaoTreinamento = false;
                })
            }
        },
        mounted() {
            this.escolaLogadaId = +auth.currentUser().tenant;
            this.escolaId = +auth.currentUser().tenant;
            this.colaboradorId = +this.$route.params.id;
            this.dialogEdit = true;
            this.verificaSessaoTreinamento();

            let _tab = +this.$route.query.tab;
            if (_tab) this.tabIndex = _tab;
            TutorStep.start("/colaborador");
        }
    };
</script>

